export enum DateTimeFormat {
    dateFormat = 'DD/MM/YYYY',
    kendoDateFormat = 'dd/MM/yyyy',
    timeFormat = 'HH:mm',
    dateTimeFormat = `${DateTimeFormat.dateFormat} ${DateTimeFormat.timeFormat}`,
    kendoDateTimeFormat = `${DateTimeFormat.kendoDateFormat} ${DateTimeFormat.timeFormat}`
}
